var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  },
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fill-0, #D0FC5A)",
  d: "M12.5 0s.69 6.437 3.376 9.124C18.563 11.81 25 12.5 25 12.5s-6.437.69-9.124 3.376C13.19 18.563 12.5 25 12.5 25s-.69-6.437-3.376-9.124C6.437 13.19 0 12.5 0 12.5s6.437-.69 9.124-3.376C11.81 6.437 12.5 0 12.5 0"
})));
export default SvgStar;